import LinkLanguage from "locales/LinkLanguage";
import PhotoDisplayHandler from "../photo/PhotoDisplayHandler";
import "./CategoryCard.scss";

const CategoryCard = ({ data, action }: any) => {
  return (
    <LinkLanguage
      className={`Category-Card-Link`}
      to={"/articles" + data.path}
      action={action}
    >
      <div className="Category-Card-First">
        <PhotoDisplayHandler
          img_name={data.background_image}
          calculate={false}
          img_class_name="Category-Card-Image"
          img_alt={data.ac_name}
          width="auto"
          height="80px"
        />
      </div>
      <div className="Category-Card-Second">
        <p className="Category-Card-Second-Name">{data.ac_name}</p>
      </div>
    </LinkLanguage>
  );
};
export default CategoryCard;
